export type DockRect = {
  left: number
  top: number
  right: number
  bottom: number
}

export type NaturalBarOffsets = {
  dyBottom: number
  dxCenter: number
  width: number
  height: number
}

export const DOCK_COLLISION_PAD_PX = 6

export const inflateRect = (r: DockRect, by: number): DockRect => ({
  left: r.left - by,
  top: r.top - by,
  right: r.right + by,
  bottom: r.bottom + by,
})

export const rectsIntersect = (a: DockRect, b: DockRect): boolean =>
  a.left < b.right && b.left < a.right && a.top < b.bottom && b.top < a.bottom

export const captureNaturalOffsets = (
  wrapper: DockRect,
  bar: DockRect,
): NaturalBarOffsets => ({
  dyBottom: wrapper.top - bar.bottom,
  dxCenter: (bar.left + bar.right) / 2 - (wrapper.left + wrapper.right) / 2,
  width: bar.right - bar.left,
  height: bar.bottom - bar.top,
})

export const naturalRectFromOffsets = (
  wrapper: DockRect,
  offsets: NaturalBarOffsets,
): DockRect => {
  const bottom = wrapper.top - offsets.dyBottom
  const centerX = (wrapper.left + wrapper.right) / 2 + offsets.dxCenter
  return {
    left: centerX - offsets.width / 2,
    right: centerX + offsets.width / 2,
    top: bottom - offsets.height,
    bottom,
  }
}
